import { Modal, Box, IconButton } from "@mui/material";

const BaseModal = ({ open, onClose, scrollable=false, children }) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="base-modal" disableAutoFocus>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", md: "60%" },
          bgcolor: "var(--base-color)",
          color: "var(--inverse-color)",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          position: "relative",
          maxHeight: scrollable ? "90vh" : "none",
          overflowY: scrollable ? "auto" : "visible"
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "var(--inverse-color)",
          }}
        >
          &#x2715;
        </IconButton>

        {children}
      </Box>
    </Modal>
  );
};

export default BaseModal;